import { useEffect, useState } from 'react'

import { faker } from '@faker-js/faker'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Title
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { ptBR } from 'date-fns/locale'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { Bar as BarJS, Doughnut } from 'react-chartjs-2'
import { useNavigate } from 'react-router-dom'
import Loader from '../../components/loader/loader'
import OperationHeader from '../headers/operation.header'
import styles from './StockDashboard.module.scss'
import { Box, FormControl, FormHelperText, Input, InputAdornment, InputLabel } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { dateToString, toInt, toStringFloat } from '../../utilities/auxiliary-functions'
import { removeFormatDate } from '../../utilities/masks'
import authService from '../../services/auth.service'
import lclService from '../../services/lcl.service'
import { MaterialType } from '../../utilities/types'
import { isEmpty } from '../../utilities/validators'
import DashboardHeader from '../headers/dashboard.header'
import { BarChart, ResponsiveContainer, CartesianGrid, Cell, LabelList, Legend, Pie, PieChart, Tooltip, XAxis, YAxis, Bar } from 'recharts';

interface IStockDashboardProps {
    
}

export const StockDashboard: React.FC<IStockDashboardProps> = () => {

    let reloadPage: boolean = false;
    const [ loading, setLoading ] = useState(false);

    const [ productFilter, setProductFilter ] = useState('');
    const [ dateFilter, setDateFilter ] = useState(new Date());

    const [ labelMaterial, setLabelMaterial ] = useState([] as any);
    const [ dataBarMaterial, setDataBarMaterial ] = useState([{ label: '', data: {} }]);
    const [ dataDoughnutMaterial, setDataDoughnutMaterial ] = useState([{ label: '', data: {} }]);
    const [ materials, setMaterials ] = useState([] as any);
    const [ material, setMaterial ] = useState({} as any);
    const [ totalProducts, setTotalProducts ] = useState(0);

    const [ labelProduct, setLabelProduct ] = useState([] as any);
    const [ dataBarProduct, setDataBarProduct ] = useState([]);
    const [ products, setProducts ] = useState([] as any);
    const [ product, setProduct ] = useState({} as any);

    const navigate = useNavigate()

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        ChartDataLabels,
        Title,
        ArcElement
    )

    const barOptions = {
        responsive: true,
        gridLines: {
            display: false
        },
        plugins: {
            legend: {
            position: 'bottom' as const,
            labels: {
                color: '#FFFFFF',
                font: {
                    size: 12,
                    family: "'Montserrat', sans-serif"
                }
            }
            },
            datalabels: {
                color: 'white',
                font: {
                    size: 12,
                    family: "'Montserrat', sans-serif"
                }
            }
        },
        maintainAspectRatio: true,
        scales: {
            x: {
                ticks: {
                    color: 'white',
                    font: {
                        size: 12,
                        family: "'Montserrat', sans-serif"
                    }
                },
                grid: {
                    display: true,
                    tickColor: 'white',
                    drawOnChartArea: false,
                    color: 'white'
                },
                border: {
                    color: 'white'
                }
            },
            y: {
                ticks: {
                    color: 'white',
                    font: {
                        size: 12,
                        family: "'Montserrat', sans-serif"
                    }
                },
                grid: {
                    display: true,
                    tickColor: 'white',
                    drawOnChartArea: false,
                    color: 'white'
                },
                border: {
                    color: 'white'
                }
            }
        }
    }

    const horizontalBarOptions = { 
        ...barOptions,
        onClick: (e: any, elements: any) => {
            if (e.type === "click" && elements.length) {
                const material = materials.find((material: any) => { return material.name === dataBarMaterial[elements[0].datasetIndex].label });
                setMaterial(material);
            }
        },
        indexAxis: 'y' as const,
        plugins: {
            legend: {
                ...barOptions.plugins.legend,
                position: 'left' as const,
            },
        },
        scales: {
            ...barOptions.scales,
            y: {
                ...barOptions.scales.y,
                ticks: {
                    ...barOptions.scales.y.ticks,
                    display: false,
                }
            }
        }
    }

    const verticalBarOptions = { 
        ...barOptions,
        indexAxis: 'x' as const,
        plugins: {
            legend: {
                ...barOptions.plugins.legend,
                display: false,
            },
        },
        scales: {
            ...barOptions.scales,
            x: {
                ...barOptions.scales.x,
                ticks: {
                    ...barOptions.scales.x.ticks,
                    display: false,
                }
            }
        },
        display: false
    }

    /*
    const verticalBarOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top' as const,
        },
        title: {
          display: false
        },
      },
    };
    */

    const legendMaterial = ['Material'];
    const legendProduct = ['Minimo', 'Atual'];

    const registerBarHMaterial = {
      labels: legendMaterial,
      datasets: dataBarMaterial
    }

    const registerCircleMaterial = {
      labels: labelMaterial,
      datasets: dataDoughnutMaterial
    }

    const bgColorMaterial = ['gray','#6783E6','#87B972','purple','#E5C710'];

    const doughnutOptions = {
        responsive: true,
        cutout: 60,
        gridLines: {
            display: false
        },
        plugins: {
            legend: {
                display: false,
                labels: {
                    color: '#FFFFFF',
                    font: {
                        size: 14,
                        family: "'Montserrat', sans-serif"
                    }
                }
            },
            datalabels: {
                color: 'white',
                font: {
                    size: 14,
                    family: "'Montserrat', sans-serif"
                },
                formatter(value: any) {
                    return `${value}%`
                }
            }
        }
    }

    const ProductTooltip = (props: any) => {

        const { active, payload } = props;

        if (active && payload && payload.length) {
            return (
                <div className="financial-accompany-tooltip">
                    <span style={{color : payload[0].color }}>{`${payload[0].name} : ${toStringFloat(payload[0].value)}`}</span>
                    <span style={{color : payload[1].color }}>{`${payload[1].name} : ${toStringFloat(payload[1].value)}`}</span>
                </div>
            );
        }
        return null;
    };

    const registerProduct = {
        labels: legendProduct,
        datasets: dataBarProduct
    };

    async function searchMaterial() {
        const partner = authService.currentPartner();
        const resultMaterials = await lclService.stockMaterial(partner.id);
        const barMaterial = [] as any;
        const doughnutDataMaterial = [] as any;

        const labels = [] as any;
        resultMaterials.forEach((material: any, index: number) => {
            labels.push(material.name);
        });
        setLabelMaterial(labels);

        var some = 0;
        resultMaterials.forEach((material: any, index: number) => {
            barMaterial.push({
                label: material.name,
                data: legendMaterial.map(() => { 
                    return material.totalProduct; 
                }),
                backgroundColor: bgColorMaterial[index],
                barPercentage: 0.9,
                datalabels: {
                    display: false
                },
            });
            some += toInt(material.totalProduct);
        });

        resultMaterials.forEach((material: any) => {
            doughnutDataMaterial.push(some > 0 ? Math.round((material.totalProduct / some) * 100) : 0);
        });

        const doughnutMaterial = [{
            data: doughnutDataMaterial,
            backgroundColor: bgColorMaterial,
            barPercentage: 0.9,
            borderWidth: 0
        }] as any;

        setTotalProducts(some);
        setDataBarMaterial(barMaterial);
        setDataDoughnutMaterial(doughnutMaterial);
        setMaterials(resultMaterials);
    }

    async function searchProduct() {
        const partner = authService.currentPartner();
        const resultProducts = await lclService.stockProduct(partner.id, material.id);

        const barProduct = [] as any;
        
        const bgColor = [] as any;
        for (let i = 0; i < resultProducts.length; i++) {
            let letters = '0123456789ABCDEF';
            let color = '#';
            for (let j = 0; j < 6; j++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            bgColor.push(color);
        }

        resultProducts.forEach((product: any, index: number) => {
            barProduct.push({
                label: product.description,
                data: { 'Minimo': product.minimum, 'Atual': product.actual },
                backgroundColor: bgColor[index]
            });
        });

        setDataBarProduct(barProduct);
        setProducts(resultProducts);
    }

    useEffect(() => {
        if (!reloadPage) {
            reloadPage = true;

            setLoading(true)
            setTimeout(() => {
                searchMaterial().finally(() => {
                setLoading(false);
                });
            }, 500);
        }
    }, [])

    useEffect(() => {
        if (!isEmpty(material))
            searchProduct();
    }, [material]);

    function viewDashboard() {
        return (
            <Container fluid className="page-body dashboards">
                <Box className="d-flex flex-column gap-2">
                    <Box className="d-flex justify-content-between gap-2">
                        <Card className='flex-grow-1'>
                            <Card.Header>
                                <Card.Title>Material</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <BarJS options={horizontalBarOptions} data={registerBarHMaterial} height={80} />
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Header>
                                <Card.Title>Total Cadastrado: {totalProducts}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Doughnut options={doughnutOptions} data={registerCircleMaterial} width={100} height={100} />
                            </Card.Body>
                        </Card>
                    </Box>
                    <Box className="d-flex justify-content-between gap-2">
                        <Card className='flex-grow-1'>
                            <Card.Header>
                                <Card.Title>Produtos</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {/* <Bar options={verticalBarOptions} data={registerProduct} height={90} /> */}
                              <ResponsiveContainer width="100%" height={400}>
                                  <BarChart data={products} height={90}>
                                      <CartesianGrid strokeDasharray="3 3" />
                                      <XAxis dataKey="name" tick={{ fill: '#FFFFFF' }} />
                                      <YAxis tick={{ fill: '#FFFFFF' }}/>
                                      <Tooltip content={<ProductTooltip />} />
                                      <Legend />
                                      <Bar barSize={100} dataKey="minimum" name='Minimo' fill="#00C49F" /> 
                                      <Bar barSize={100} dataKey="actual" name='Atual' fill="#FF8042" />
                                  </BarChart>
                              </ResponsiveContainer>
                            </Card.Body>
                        </Card>
                    </Box>
                </Box>
            </Container>
        )
    }

    return (
        <div className="dashboard">
            <DashboardHeader title="Gestão de Estoque" description="" />
            {loading ? <Loader /> : viewDashboard()}
        </div>
    )
}

export default StockDashboard
